// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__35O9K","empty":"ModalGraph_empty__2r9Go"};